import { render, staticRenderFns } from "./FlagsMenu.vue?vue&type=template&id=65924dfc&scoped=true"
import script from "./FlagsMenu.vue?vue&type=script&lang=js"
export * from "./FlagsMenu.vue?vue&type=script&lang=js"
import style0 from "./FlagsMenu.vue?vue&type=style&index=0&id=65924dfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65924dfc",
  null
  
)

export default component.exports